'use client'

/* ---------------------------------
Quotations
--------------------------------- */

import React from 'react'
import { Card, Section } from '@dynamo-caffeina-dev/airc-ui-kit'
import { NormalizedSection } from '@/types'

export default function Quotations({
  modelledContent: extractedContent,
}: NormalizedSection): React.JSX.Element {
  const { quotations } = extractedContent ?? {}

  return (
    <Section className='section-quotations'>
      <div className='section-quotations__container'>
        {quotations?.map?.((quotation: string, i: number) => (
          <Card
            className={'section-quotations__card'}
            key={`quotation-${i}`}
          >
            <div dangerouslySetInnerHTML={{ __html: quotation }}></div>
          </Card>
        ))}
      </div>
    </Section>
  )
}
